export const BUILD_ID = '8a005ecb-bc30-411e-a638-f52f9bcb05c3';
export const ENV = 'dev';
